export default __webpack_public_path__ + "static/ASLA_Linia_1a-b7d52d243c6f5eaae2266dc59c62fa2d.png";